import { Box } from '#/components/Box/Box';
import { Text } from '#/components/Text/Text';
import { useI18n } from '#/i18n/hooks/useI18n';
import { colors } from '#/theme/theme';

type Props = {
  maxLength: number;
  currentCount: number;
};

export function CharacterCounter({ maxLength, currentCount }: Props) {
  const { i18n } = useI18n();
  const charsLeft = maxLength - currentCount;
  return (
    <Box mt="5px" display="flex" justifyContent="flex-end">
      <Text
        styleAs="bodySmall"
        color={charsLeft === 0 ? colors.alertRed : colors.mediumContentGrey}
      >
        {charsLeft === 1
          ? i18n('%(count)s character left', { count: charsLeft })
          : i18n('%(count)s characters left', { count: charsLeft })}
      </Text>
    </Box>
  );
}
